import { useRef } from 'react';
import isEqual from 'react-fast-compare';

export default function useIsEqualMemoize(value) {
  const ref = useRef();

  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}
